import React from 'react';

export const AmexIcon = () => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3620_54455)">
        <path
          d="M22 0H2C0.89543 0 0 0.89543 0 2V14C0 15.1046 0.89543 16 2 16H22C23.1046 16 24 15.1046 24 14V2C24 0.89543 23.1046 0 22 0Z"
          fill="#016FD0"
        />
        <path
          d="M13.7637 13.3944V7.69238L23.9117 7.70238V9.27638L22.7387 10.5304L23.9117 11.7954V13.4034H22.0387L21.0437 12.3054L20.0557 13.4074L13.7637 13.3944Z"
          fill="#FFFFFE"
        />
        <path
          d="M14.4414 12.7693V8.31934H18.2134V9.34534H15.6634V10.0403H18.1534V11.0483H15.6634V11.7323H18.2134V12.7693H14.4414Z"
          fill="#016FD0"
        />
        <path
          d="M18.1953 12.7693L20.2833 10.5423L18.1953 8.32031H19.8113L21.0863 9.73031L22.3663 8.32031H23.9123V8.35531L21.8693 10.5423L23.9123 12.7063V12.7693H22.3503L21.0523 11.3453L19.7673 12.7693H18.1953Z"
          fill="#016FD0"
        />
        <path
          d="M14.2366 2.63184H16.6826L17.5426 4.58184V2.63184H20.5626L21.0826 4.09384L21.6056 2.63184H23.9116V8.33284H11.7246L14.2366 2.63184Z"
          fill="#FFFFFE"
        />
        <path
          d="M14.7006 3.251L12.7266 7.697H14.0806L14.4536 6.807H16.4716L16.8436 7.697H18.2306L16.2656 3.25L14.7006 3.251ZM14.8706 5.809L15.4626 4.394L16.0546 5.809H14.8706Z"
          fill="#016FD0"
        />
        <path
          d="M18.2129 7.69602V3.25002L20.1159 3.25602L21.0959 5.98902L22.0809 3.24902H23.9129V7.69502L22.7339 7.70502V4.65302L21.6209 7.69602H20.5459L19.4099 4.64202V7.69602H18.2129Z"
          fill="#016FD0"
        />
      </g>
      <defs>
        <clipPath id="clip0_3620_54455">
          <rect width="24" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
